import { strict } from 'assert';

import type { SanityFormSelect } from '#/lib/sanity/queries/form';
import type { SanityFormConfirmation } from '#/lib/sanity/queries/formConfirmation';

import { ContactForm } from '../Contact';
import { FormCustomEnriched } from './Enriched';
import { FormCustomMultiStep } from './MultiStepForm';
import { FormCustomSingle } from './SingleForm';

type Props = {
  form: SanityFormSelect;
  confirmation: SanityFormConfirmation | string;
  onSubmitSuccess?: () => void;
  onSubmitError?: () => void;
  className?: string;
  theme?: 'light' | 'dark';
  /** Confirmation CTA surface theme; defaults to `theme` when omitted. */
  buttonTheme?: 'light' | 'dark';
};

export function FormCustom(props: Props) {
  strict(process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY);

  if (props.form.formType === 'default') {
    return (
      <FormCustomSingle
        theme={props.theme}
        buttonTheme={props.buttonTheme}
        className={props.className}
        form={props.form}
        confirmation={props.confirmation}
        onSubmitSuccess={props.onSubmitSuccess}
        onSubmitError={props.onSubmitError}
      />
    );
  }

  if (props.form.formType === 'multistep') {
    return (
      <FormCustomMultiStep
        theme={props.theme}
        buttonTheme={props.buttonTheme}
        className={props.className}
        form={props.form}
        confirmation={props.confirmation}
        onSubmitSuccess={props.onSubmitSuccess}
        onSubmitError={props.onSubmitError}
      />
    );
  }

  if (props.form.formType === 'enriched') {
    return (
      <FormCustomEnriched
        theme={props.theme}
        buttonTheme={props.buttonTheme}
        className={props.className}
        form={props.form}
        confirmation={props.confirmation}
        onSubmitSuccess={props.onSubmitSuccess}
        onSubmitError={props.onSubmitError}
      />
    );
  }

  if (props.form.formType === 'contact') {
    return (
      <ContactForm
        className={props.className}
        form={props.form}
        confirmation={props.confirmation}
        theme={props.theme}
        buttonTheme={props.buttonTheme}
        onSubmitSuccess={props.onSubmitSuccess}
        onSubmitError={props.onSubmitError}
      />
    );
  }
}
